export default __webpack_public_path__ + "static/media/ic-internet_big.5016f546.svg";